import { render } from "./SearchInstitution.vue?vue&type=template&id=22e95445&scoped=true"
import script from "./SearchInstitution.vue?vue&type=script&lang=js"
export * from "./SearchInstitution.vue?vue&type=script&lang=js"

import "./SearchInstitution.vue?vue&type=style&index=0&id=22e95445&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22e95445"]])

export default __exports__